/**
 * Created by richard on 9/12/14.
 */
var schoolTaxSchoolModel = angular.module('schoolTaxSchoolModel', ['schoolTaxModel', 'schoolModel']);
schoolTaxSchoolModel.service('SchoolTaxSchoolService', function(ApplicationService, SchoolTaxModelService,
                                                                     SchoolModelService, $q){
    return {
        putHelper: function (putDataSchoolTax, putDataSchool, callback)
        {
            $q.all([
                SchoolTaxModelService.put(putDataSchoolTax.schoolID, putDataSchoolTax),
                SchoolModelService.put(putDataSchoolTax.schoolID, putDataSchool)
            ]).then(callback);
        }
    }
});